// import Cookies from 'js-cookie'
import axios from 'axios';
import { api } from "@/utils/api";
const app = {
  state: {
    userInfo: sessionStorage.getItem("userInfo") || {}
  },
  mutations: {
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    }
  },
  actions: {
    getMztUserInfo({commit}, data) {
      let formData = new FormData();
      formData.append("POSTPARAM_JSON", JSON.stringify({
        "INVOKESERVICE_CODE": "033",
        "INVOKECALLER_CODE": "2bf26e96740adbedda3917e8d72f1989f1d3c8d9",
        "USER_ID": data.userId,
        "USER_TOKEN": data.userToken
      }))
      return new Promise((resolve, reject) => {
        axios.post("https://mztapp.fujian.gov.cn:8304/dataset/AppSerController/invokeservice.do", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(res => {
          let resData = res.data;
          if (resData.success) {
            api({
              method: "qfwMztAccount/updateOrSaveMztAccount",
              obj: resData.data,
            }).then(result => {
              let userInfo = result.data;
              if (result.code === '200') {
                // 将用户信息保存到缓存
                sessionStorage.setItem("userInfo", userInfo);
                // 将用户信息保存到vue store中
                commit("SET_USER_INFO", userInfo);
                resolve();
              } else {
                reject();
              }
            }).catch(err => {
              reject();
            });
          } else {
            reject();
          }
        }).catch(err => {
          reject();
        })
      });
    },
    getWxUserInfo({commit}, data) {
      return new Promise((resolve, reject) => {
        api({
          method: "wx/account/getWxAccountInfo",
          obj: {openId: data.openId},
        }).then(result => {
          let userInfo = result.data;
          if (result.code === '200') {
            // 将用户信息保存到缓存
            sessionStorage.setItem("userInfo", userInfo);
            // 将用户信息保存到vue store中
            commit("SET_USER_INFO", userInfo);
            resolve();
          } else {
            reject();
          }
        }).catch(err => {
          reject();
        });
      });
    },
    addErrorLog(errorInfo) {
      return new Promise((resolve, reject) => {
        let data = {
          systemName: window.g.areaName,
          errorInfo: errorInfo
        };
        axios.post("https://h5.qzdsj.com.cn/qzqfwqx/prod/zuul/bmhq-log/h5/log/add", data).then(res => {
          resolve()
        }).catch(err => {
          resolve()
        })
      });
    }
  }
}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js